import { render, staticRenderFns } from "./headersPage.html?vue&type=template&id=74e4e9d4&"
import script from "./headersPage.vue?vue&type=script&lang=js&"
export * from "./headersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports